import { render } from "./Categories.vue?vue&type=template&id=f26a90a8&scoped=true&ts=true"
import script from "./Categories.vue?vue&type=script&lang=ts"
export * from "./Categories.vue?vue&type=script&lang=ts"

import "./Categories.vue?vue&type=style&index=0&id=f26a90a8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/on-the-edge-client/on-the-edge-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f26a90a8"]])

export default __exports__